import AuthenticatedClient from './clients/AuthenticatedClient'
import Client from './clients/Client'
import { analyticsHeaders, signupAttribution, trackSharedArticleConversion } from '@/composables/useAnalytics'
const resource = '/email'

/**
 * Public email endpoints (`/email`) — captcha, contact form, newsletter.
 * Methods return the raw AxiosResponse; callers read `.data`.
 */
export default {
  /** Save an email-only demo contact request in the CRM inbox. */
  requestDemoContact (payload) {
    return Client.post(`${resource}/demo`, payload)
  },
  /** Fetch a captcha challenge. @returns {Promise<import('axios').AxiosResponse>} */
  getCaptcha () {
    return Client.get(`${resource}/captcha`, { timeout: 10000 })
  },
  /** Submit the contact form. @param {object} payload @returns {Promise<import('axios').AxiosResponse>} */
  submitContactForm (payload) {
    return Client.post(`${resource}/contact`, payload)
  },
  /** Submit an authenticated contact form without captcha. @param {object} payload @returns {Promise<import('axios').AxiosResponse>} */
  submitAuthenticatedContactForm (payload) {
    return AuthenticatedClient.post(`${resource}/contact/authenticated`, payload)
  },
  /** Subscribe to the newsletter. @param {object} payload @returns {Promise<import('axios').AxiosResponse>} */
  subscribeNewsletter (payload) {
    return Client.post(`${resource}/subscribe`, { ...payload, attribution: signupAttribution() }, { headers: analyticsHeaders() }).then((response) => {
      trackSharedArticleConversion('newsletter_request')
      return response
    })
  }
}
